import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="h-10 w-10 rounded-full bg-primary flex items-center justify-center">
                <Stethoscope className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold">Alambana Healthcare</h3>
                <p className="text-xs">Sejal Engitech Pvt Ltd</p>
              </div>
            </div>
            <p className="text-sm">AI-integrated healthcare platform connecting patients with verified doctors.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact Us</Link></li>
              <li><Link to="/doctors" className="hover:text-primary transition-colors">Find Doctors</Link></li>
              <li><Link to="/ai-checker" className="hover:text-primary transition-colors">AI Symptom Checker</Link></li>
              <li><Link to="/blogs" className="hover:text-primary transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/disclaimer" className="hover:text-primary transition-colors">Medical Disclaimer</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:info@alambanahealthcare.com" className="hover:text-primary transition-colors">
                  info@alambanahealthcare.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} Alambana Healthcare – A Unit of Sejal Engitech Pvt Ltd</p>
          <p className="mt-2">Website Managed by Sejal Engitech Pvt Ltd | All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
